import React, { Component } from 'react';
import { connect } from 'react-redux';
import {lowestDenom, shortenHash} from '../../../../config';
import TakeOrders from './details';
import { Decimal } from "decimal.js";

class TakingOrders extends Component {
  constructor(){
    super();
    this.state = {amount:0,to:0,name:"BTC",view:'overview'};
  }
  setview(view){
    this.setState({view})
  }
  item(key,val){
    return (
      <div className="row mi">
        <h6 className='leftInfo'>{key}</h6>
        <h6 className="rightInfo">{val}</h6>
      </div>
    )
  }
  overview(){
    let trade1 = this.props.tradeAddresses[this.props.sendsFromChain.toLowerCase()];
    let trade2= this.props.tradeAddresses[this.props.receivesToChain.toLowerCase()];
    return (
      <div className='col s12' style={{display:this.state.view === "overview" ? '' : 'none'}}>
        {this.item('Type', this.props.orderType)}
        {this.item(`Price (${this.props.denomination.replace('NRG','OVERLINE')})`, this.props.price)}
        {this.item(`Amount (${this.props.asset})`, this.props.amount)}
        {this.item(`Collateral (OVERLINE)`, this.props.collateral)}
        <div className="row mi"><hr/></div>
        {this.item(`Send From Address (${this.props.sendsFromChain.replace('NRG','OVERLINE')})`, trade1 ? shortenHash(trade1,6) : null)}
        {this.item(`Receive To Address (${this.props.receivesToChain.replace('NRG','OVERLINE')})`, trade2 ? shortenHash(trade2,6) : null)}
        {this.item(`Collateral Address`, this.props.tradeAddresses.nrg ? shortenHash(this.props.tradeAddresses.nrg,6) : null)}
      </div>
    )
  }
  details(){
    return (
      <div className='col s12' style={{display:this.state.view === "details" ? '' : 'none'}}>
        <TakeOrders/>
      </div>
    )
  }
  render() {

    let trade1 = this.props.tradeAddresses[this.props.sendsFromChain.toLowerCase()];
    let trade2= this.props.tradeAddresses[this.props.receivesToChain.toLowerCase()];


    let mnemStyle = this.state.view === "details" ? {color: "black"} : { color: "grey",borderBottom:'1px solid black', borderLeft:'1px solid black'};
    let jsonStyle = this.state.view === "overview" ? {color: "black"} : { color: "grey",borderBottom:'1px solid black', borderRight:'1px solid black'};

    return (
      <div className="row mbd">
        <div className="col s6" style={{...jsonStyle,cursor:'pointer',padding:0}}>
          <h5 className='padding5' onClick={this.setview.bind(this, "overview")} style={{fontSize:'1.3rem',textAlign:'center'}}>
            overview
          </h5>
        </div>
        <div className="col s6" style={{...mnemStyle,cursor:'pointer',padding:0}}>
          <h5 className='padding5' onClick={this.setview.bind(this, "details")} style={{fontSize:'1.3rem',textAlign:'center'}}>
            details
          </h5>
        </div>
        <div className='col s12' style={{maxHeight:'350px',overflowY:'scroll'}}>
        {this.overview()}
        {this.details()}
        </div>
      </div>
		)
  }
}

function mapStateToProps(state,props) {

  let {denomination,asset,type} = state.ui_marketplace.market;
  let sendsFromChain = state.ui_marketplace.orderType === 'BUY' ? denomination : asset;
  let receivesToChain = state.ui_marketplace.orderType === 'BUY' ? asset : denomination;

  let totalCollateral = new Decimal(0)
  state.ui_marketplace.takeOrders.map(({fixedUnitFee,amount,takeAmount,collateralizedNrg},i) => {
    let modifiedCollateral = new Decimal(collateralizedNrg).mul(new Decimal(takeAmount)).div(new Decimal(amount))
    if (fixedUnitFee !== "0") modifiedCollateral = new Decimal(fixedUnitFee);
    totalCollateral = totalCollateral.add(modifiedCollateral)
  })

  if(state.ui_marketplace.makerAmount && state.ui_marketplace.price != 0) {
    if(sendsFromChain == 'NRG') {
      totalCollateral = totalCollateral.add(new Decimal(state.ui_marketplace.makerAmount).mul(new Decimal(state.ui_marketplace.price)))
    }
    else {
      totalCollateral = totalCollateral.add(new Decimal(state.ui_marketplace.makerCollateral)).toNumber();
    }
  }

  return {
    collateral: totalCollateral.toString(),
    denomination,
    asset,
    orderType: state.ui_marketplace.orderType,
    price: state.ui_marketplace.price,
    amount:state.ui_marketplace.amount,
    tradeAddresses: state.passport.tradeAddresses,
    sendsFromChain,
    receivesToChain,
  };
}

export default connect(mapStateToProps, {})(TakingOrders);
